
import React, { useState, useRef, useEffect, Fragment } from "react";
import "./../components/Report.css";
import { _hasPermission } from "../../../../../../shared/helpers/access";
import { _axiosCall } from "../../../../../../shared/helpers/apicalls";
import moment from "moment";
import CustomLineChart from "./../components/CustomLineChart";
import { formatDateRange, calculatePercentageChange, previousYearPeriod, generatePeriodNames, percentageChange, validateNestedData } from "../../../exportreport/utils"
import {
  _capitalizeText,
  _formatNumber,
  _formatPrice,
  _formatCurrency,
  _nameToUrl,
  _shouldShow,
  _getBuildingURL,
  buildingFL,
  _replaceAbbreviations,
  _formatBed,
  propertyFL,
  SalesProgress,
  _isEqual,
  _tranformTagsQuery,
  syncURLFilters,
  syncURLSearch,
  setURLFromState,
  setLocalStorage,
  getLocalStorage,
  deleteLocalStorage,
  syncStageFilters,
  mpndCohortQuery,
  syncGenericFilter,
  urlSlugBuilding,
  _isNewUser,
  _isEnterpriseUser,
  _objectEqual,
  getCohortQuery,
  _activityFQ,
  _isHouse,
  _formatBigPrice,
  houseBuildingCohortQuery,
  _activityFL,
} from "../../../../../../shared/helpers/utils";
import Stats from "./../components/Stats";
import UserProfile from "../../components/UserProfile";
import Footer from "./Footer";
import CustomSkeleton from "./Skeleton";

const PropertyTypePage = (props) => {
    const { name, title, type, reportData, searchTags, summarizeGeographies, priorYearPeriodName,logo, currentPeriodName, customDate, color, user, formValues, AiResponse, defaultLogo, isLux } = props;
	const { dateOptions, theme, style ,branding} = customDate;
    const hasLocation = searchTags && searchTags.length>0;
    const chartData =  validateNestedData(
      reportData,
      `facets.all.contract_signed.chart`
    )
      ? reportData.facets.all.contract_signed.chart.buckets.slice(reportData.facets.all.contract_signed.chart.buckets.length - 13, reportData.facets.all.contract_signed.chart.buckets.length).map(item => ({date : formatDateRange(null, null, item.val), val: item.count ? Math.round(item.count) : 0})) : [];
      
    const UserContact = () => {
      return <>{customDate && customDate.contact && customDate.contact === "show" ? <section className="user-contact">
       
      <div className={`contact editable`}>
        <div className="user-container">
        {user && user.avatar && !user.avatar.endsWith('/account.png') ? <div
          className="avatar-img"
          style={{ backgroundImage: `url(${user.avatar})` }}
          alt="avatar"
        />:null}
        <div>
        <p className="name editable">
          {user.firstName} {user.lastName}
        </p>
        <div className="contact-title">
          {user.title && <span className="editable">{user.title}</span>}
          {user.company && (
            <span className="editable">
              {" | "}
              {user.company}
            </span>
          )}
        
         
        </div>
        <div className="contact-info">
          {user.email && <span className="editable">{user.email}</span>}
          {user.primaryPhone && (
            <span className="editable">
              {" | "}
              {user.primaryPhone}
            </span>
          )}
        </div>
      
        </div>
        </div>
        </div>
        </section> : null }</>
    }
    return (
      <>
        <div className="news-letter-daily-deals-container page-section">
          <section className="news-header-wrapper">
            <div className="news-sub-heading-main">
              <section className="social-branding">
                {branding && branding && branding === "mylogo" && logo ? (
                  <div className="brand-logo">
                    <div>
                      <img
                        className="header-logo"
                        src={logo}
                        style={{ maxHeight: 70 }}
                      />
                    </div>
                  </div>
                ) : branding && branding && branding === "marketproof" ? (
                  <div className="brand-logo">
                    <div>
                      <img
                        src={defaultLogo}
                        style={{ maxHeight: 70 }}
                      />
                    </div>
                  </div>
                ) : null}
                <UserProfile formValues={formValues} user={user} />
              </section>
            
            </div>
            
            <div className="heading editable">{type.name}</div>
            <h3 className="header-text heading-location editable">{searchTags && searchTags.length>0 ? _capitalizeText(summarizeGeographies(searchTags)) : "New York City"}</h3>
            <div className="sub-header-wrapper">
             <div className="sub-header-type editable">{type.title}</div>
             <div className="sub-header-type date editable">{currentPeriodName}</div>
            </div>
          </section>
          <section className="content-news-section">
            {/* <section className="news-report-info">
              <div className="report-date editable">{currentPeriodName}</div>
              <div className="division editable">{searchTags && searchTags.length>0 ? _capitalizeText(summarizeGeographies(searchTags)) : "New York City"}</div>
            </section> */}
            <section className="flex-section flex-top">
              <div className="left-side-flex">
              <div className="summary-text editable">
                { AiResponse && AiResponse.contract_signed? AiResponse.contract_signed: <CustomSkeleton count={20}/>}
               </div>
               </div>
               <div className="right-side-flex">
               <div className="total-sub-market">
                 <h2 className="section-main-heading  editable">Contracts</h2>
                 <Stats
                   data={[
                     { name: "Contracts", value: (validateNestedData(
                       reportData,
                       `facets.all.contract_signed.current_period.count`
                     ) ? _formatNumber(
                           reportData.facets.all.contract_signed.current_period.count
                         )
                       : "--") },
                     
                     { name: "Avg Price", value: (validateNestedData(
                       reportData,
                       `facets.all.contract_signed.current_period.avg_price`
                     ) 
                       ? `${_formatPrice(
                           reportData.facets.all.contract_signed.current_period
                             .avg_price)}`
                       : "--") },
                     { name: "Avg PPF", value: (validateNestedData(
                       reportData,
                       `facets.all.contract_signed.current_period.ppsf.avg`
                     )  ? `$${_formatNumber(
                           reportData.facets.all.contract_signed.current_period
                             .ppsf.avg)}`
                       : "--") },
                  
                     { name: "DOM", value: (validateNestedData(
                       reportData,
                       `facets.all.contract_signed.current_period.dom.avg`
                     ) 
                       ? `${_formatNumber(
                           reportData.facets.all.contract_signed.current_period
                             .dom.avg)}` : "--") },
                   ]}
                 />
               </div>
               <hr/>
               <div class="contract-activity">
                 
                 <CustomLineChart
                   data={chartData}
                   theme={theme}
                   isWeekly={dateOptions.gap}
                 />
               </div>
            </div>
            </section>
            <section className="flex-section">
              
              
              
              <div className="left-side-flex">
                <div className="img-outer-container">
                 
                
                </div>
                <h2 className="section-main-heading right-side-sub-heading  editable">
                  Top Buildings
                </h2>
                <div className="inventory-container">
                 
                  {validateNestedData(
                    reportData,
                    `facets.all.contract_signed.current_period.buildings.buckets`
                  ) ?
                  <>
                    {reportData.facets.all.contract_signed.current_period.buildings.buckets.map((building, index) => {
                    return <div key={index}><strong>{building.by_name && building.by_name.buckets.length>0 && building.by_name.buckets.filter(d => d.val !="").length > 0 ? _capitalizeText(building.by_name.buckets.filter(d => d.val !="")[0].val) : _capitalizeText(building.val)}</strong><br/>{building.count} Contracts</div>;
                  })} 
                   </>: null
                }
                </div>
                {/*<div className="brand-name-container">
                <div className="summary-text editable">
                 {reportData && reportData.aiResponse && reportData.aiResponse.low_high_price}
                </div>
                </div> */}
              </div>
              <div className="right-side-flex">
                
                <hr/>
                <div class="contract-activity">
                  
                
                  {/* <h2 className="section-main-heading  editable">Contract Trends</h2> */}
                  {!isLux ? 
                  <>
                  <div className="stat-line">
                  <h3>Less than $1M</h3>
                  <Stats
                    data={[
                      { name: "Contracts", value: (validateNestedData(
                        reportData,
                        `facets.all.contract_signed.current_period.under_one.count`
                      ) ? _formatNumber(
                            reportData.facets.all.contract_signed.current_period.under_one.count
                          )
                        : "--") },
                      
                      { name: "Avg Price", value: (validateNestedData(
                        reportData,
                        `facets.all.contract_signed.current_period.under_one.avg_price`
                      ) 
                        ? `${_formatPrice(
                            reportData.facets.all.contract_signed.current_period.under_one
                              .avg_price)}`
                        : "--") },
                      { name: "Avg PPF", value: (validateNestedData(
                        reportData,
                        `facets.all.contract_signed.current_period.under_one.ppsf.avg`
                      )  ? `$${_formatNumber(
                            reportData.facets.all.contract_signed.current_period.under_one
                              .ppsf.avg)}`
                        : "--") },
                      
                      { name: "DOM", value: (validateNestedData(
                        reportData,
                        `facets.all.contract_signed.current_period.under_one.dom.avg`
                      ) 
                        ? `${_formatNumber(
                            reportData.facets.all.contract_signed.current_period.under_one
                              .dom.avg)}` : "--") },
                    ]}
                  />
                  </div>
                  <div className="stat-line">
                  <h3>$1M to $2M</h3>
                  <Stats
                    data={[
                      { name: "Contracts", value: (validateNestedData(
                        reportData,
                        `facets.all.contract_signed.current_period.one_to_two.count`
                      ) ? _formatNumber(
                            reportData.facets.all.contract_signed.current_period.one_to_two.count
                          )
                        : "--") },
                      
                      { name: "Avg Price", value: (validateNestedData(
                        reportData,
                        `facets.all.contract_signed.current_period.one_to_two.avg_price`
                      ) 
                        ? `${_formatPrice(
                            reportData.facets.all.contract_signed.current_period.one_to_two
                              .avg_price)}`
                        : "--") },
                      { name: "Avg PPF", value: (validateNestedData(
                        reportData,
                        `facets.all.contract_signed.current_period.one_to_two.ppsf.avg`
                      )  ? `$${_formatNumber(
                            reportData.facets.all.contract_signed.current_period.one_to_two
                              .ppsf.avg)}`
                        : "--") },
                     
                      { name: "DOM", value: (validateNestedData(
                        reportData,
                        `facets.all.contract_signed.current_period.one_to_two.dom.avg`
                      ) 
                        ? `${_formatNumber(
                            reportData.facets.all.contract_signed.current_period.one_to_two
                              .dom.avg)}` : "--") },
                    ]}
                  />
                  </div>
                  <div className="stat-line">
                  <h3>$2M to $4M</h3>
                  <Stats
                    data={[
                      { name: "Contracts", value: (validateNestedData(
                        reportData,
                        `facets.all.contract_signed.current_period.two_to_four.count`
                      ) ? _formatNumber(
                            reportData.facets.all.contract_signed.current_period.two_to_four.count
                          )
                        : "--") },
                      
                      { name: "Avg Price", value: (validateNestedData(
                        reportData,
                        `facets.all.contract_signed.current_period.two_to_four.avg_price`
                      ) 
                        ? `${_formatPrice(
                            reportData.facets.all.contract_signed.current_period.two_to_four
                              .avg_price)}`
                        : "--") },
                      { name: "Avg PPF", value: (validateNestedData(
                        reportData,
                        `facets.all.contract_signed.current_period.two_to_four.ppsf.avg`
                      )  ? `$${_formatNumber(
                            reportData.facets.all.contract_signed.current_period.two_to_four
                              .ppsf.avg)}`
                        : "--") },
                      
                      { name: "DOM", value: (validateNestedData(
                        reportData,
                        `facets.all.contract_signed.current_period.two_to_four.dom.avg`
                      ) 
                        ? `${_formatNumber(
                            reportData.facets.all.contract_signed.current_period.two_to_four
                              .dom.avg)}` : "--") },
                    ]}
                  />
                  </div> 
                </> : null}
                  <div className="stat-line">
                  <h3>$4M to $10M</h3>
                  <Stats
                    data={[
                      { name: "Contracts", value: (validateNestedData(
                        reportData,
                        `facets.all.contract_signed.current_period.four_to_ten.count`
                      ) ? _formatNumber(
                            reportData.facets.all.contract_signed.current_period.four_to_ten.count
                          )
                        : "--") },
                      
                      { name: "Avg Price", value: (validateNestedData(
                        reportData,
                        `facets.all.contract_signed.current_period.four_to_ten.avg_price`
                      ) 
                        ? `${_formatPrice(
                            reportData.facets.all.contract_signed.current_period.four_to_ten
                              .avg_price)}`
                        : "--") },
                      { name: "Avg PPF", value: (validateNestedData(
                        reportData,
                        `facets.all.contract_signed.current_period.four_to_ten.ppsf.avg`
                      )  ? `$${_formatNumber(
                            reportData.facets.all.contract_signed.current_period.four_to_ten
                              .ppsf.avg)}`
                        : "--") },
                      
                      { name: "DOM", value: (validateNestedData(
                        reportData,
                        `facets.all.contract_signed.current_period.four_to_ten.dom.avg`
                      ) 
                        ? `${_formatNumber(
                            reportData.facets.all.contract_signed.current_period.four_to_ten
                              .dom.avg)}` : "--") },
                    ]}
                  />
                  </div>
                  <div className="stat-line">
                  <h3>More than $10M</h3>
                  <Stats
                    data={[
                      { name: "Contracts", value: (validateNestedData(
                        reportData,
                        `facets.all.contract_signed.current_period.ten_plus.count`
                      ) ? _formatNumber(
                            reportData.facets.all.contract_signed.current_period.ten_plus.count
                          )
                        : "--") },
                      
                      { name: "Avg Price", value: (validateNestedData(
                        reportData,
                        `facets.all.contract_signed.current_period.ten_plus.avg_price`
                      ) 
                        ? `${_formatPrice(
                            reportData.facets.all.contract_signed.current_period.ten_plus
                              .avg_price)}`
                        : "--") },
                      { name: "Avg PPF", value: (validateNestedData(
                        reportData,
                        `facets.all.contract_signed.current_period.ten_plus.ppsf.avg`
                      )  ? `$${_formatNumber(
                            reportData.facets.all.contract_signed.current_period.ten_plus
                              .ppsf.avg)}`
                        : "--") },
                    
                      { name: "DOM", value: (validateNestedData(
                        reportData,
                        `facets.all.contract_signed.current_period.ten_plus.dom.avg`
                      ) 
                        ? `${_formatNumber(
                            reportData.facets.all.contract_signed.current_period.ten_plus
                              .dom.avg)}` : "--") },
                    ]}
                  />
                  </div>
                  
                </div>
              </div>
              
            
            </section>
            <button className="email-cta editable">Learn More</button>
            
          </section>
          
          <Footer UserContact={UserContact} />
        </div>
      </>
    );
}


export default PropertyTypePage